import React, { useState, useEffect } from "react";
import { setGlobalLoading } from "../context/LoaderController";
import { useNavigate } from "react-router-dom";
import "../App.css";
import { fetchStates } from "../services/api";
import {
  WELCOME_TITLE,
  WELCOME_DESCRIPTION,
  CHOOSE_STATE_LABEL,
  LOADING_STATES,
  ERROR_LOADING_STATES,
  PLEASE_SELECT_STATE,
  LOCALSTORAGE_SELECTED_STATE_CODE,
  LOCALSTORAGE_SELECTED_STATE_NAME,
  EVENT_STATE_CHANGE,
  ROUTE_STATE_SCHEDULE,
} from "../components/constants";

export default function Home() {
  const [states, setStates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // Clear selected state whenever user comes to home page
  useEffect(() => {
    localStorage.removeItem(LOCALSTORAGE_SELECTED_STATE_CODE);
    localStorage.removeItem(LOCALSTORAGE_SELECTED_STATE_NAME);

    // Notify header
    window.dispatchEvent(new CustomEvent(EVENT_STATE_CHANGE));
  }, []);

  // Load states
  useEffect(() => {
    let mounted = true;
    const loadStates = async () => {
      try {
        setGlobalLoading(true);
        setError(null);
        const data = await fetchStates();
        if (mounted) setStates(data);
      } catch (err) {
        if (mounted) setError("States not loaded.");
      } finally {
        if (mounted) {
          setLoading(false);
          setGlobalLoading(false);
        }
      }
    };
    loadStates();
    return () => {
      mounted = false;
    };
  }, []);

  const handleStateChange = (code, name) => {
    try {
      localStorage.setItem(LOCALSTORAGE_SELECTED_STATE_CODE, code);
      localStorage.setItem(LOCALSTORAGE_SELECTED_STATE_NAME, name);

      // Notify header that a state has been chosen
      window.dispatchEvent(new CustomEvent(EVENT_STATE_CHANGE));

      navigate(ROUTE_STATE_SCHEDULE, {
        state: { stateCode: code, stateName: name },
      });
    } catch (e) {
      console.error("Error saving state selection:", e);
    }
  };

  return (
    <div className="main-container">
      <h2 className="section-title">{WELCOME_TITLE}</h2>
      <p style={{ marginTop: 6, marginBottom: 24, fontSize: 16 }}>{WELCOME_DESCRIPTION}</p>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: 20,
          flexWrap: "wrap",
          marginBottom: 24,
        }}
      >
        <div className="form-column">
          <label htmlFor="state-select" style={{ display: "block", marginBottom: 6 }}>
            {CHOOSE_STATE_LABEL}
          </label>
          <select
            id="state-select"
            className="state-select"
            disabled={loading || !!error}
            onChange={(e) => {
              const val = e.target.value;
              const selected = states.find((s) => s.code === val);
              if (selected) handleStateChange(selected.code, selected.name);
            }}
          >
            <option value="">
              {loading
                ? LOADING_STATES
                : error
                ? ERROR_LOADING_STATES
                : PLEASE_SELECT_STATE}
            </option>

            {states.map((s) => (
              <option key={s.code} value={s.code}>
                {s.name}
              </option>
            ))}
          </select>
          {error && <p style={{ color: "red", marginTop: 8 }}>{error}</p>}
        </div>
      </div>
    </div>
  );
}
